import { GetListOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

/**
 * Чат спецификации (ТЗ 4.1, 6.10): один чат, его лента, создание трёхстороннего чата
 * (create — базовой операцией, тело { specification, supplier, text, files }).
 * Двусторонние чаты создаёт сервер. Сгенерировано Claude.
 */
export default class SpecChatApi extends BaseApi {
  static entityName = 'spec_chats';

  /** Лента чата: сообщения участников и системные события по времени (ТЗ 4.1, 8.3). */
  fetchMessages(id, withPreloader = false) {
    const operation = new GetListOperation(`${this.getIri(id)}/messages`);
    return this.execute(operation, withPreloader);
  }

  /** «Мои чаты» поставщика по всем спецификациям, где он участник (ТЗ 4.2, 6.10). */
  fetchMine(withPreloader = false) {
    const operation = new GetListOperation(this.getIri());
    return this.execute(operation, withPreloader);
  }
}
